import React from 'react'
import { useForm } from '@formspree/react';
import './Contact.css'
import { toast } from 'react-toastify';

function Contact() {
  const [state, handleSubmit] = useForm("xoqzlqyr");
  if (state.succeeded) {
    state.succeeded = false;
    document.getElementById("contact-form").reset();
    toast.success("Thanks for your message! I'll get back to you as soon as possible.")
  }
  return (
    <>
      {/* {state.succeeded && toast.success("Thanks for your message! I'll get back to you as soon as possible.") && document.getElementById("contact-form").reset()} */}
      <div class="contact_us_green">
        <div className="header-text-h1">
          <h1 className='header-text'>Get In Touch</h1>
        </div>
        <div class="responsive-container-block big-container">
          <div class="responsive-container-block container">
            <div class="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-7 wk-ipadp-10 line" id="i69b-2">
              <form class="form-box" onSubmit={handleSubmit} method='post' id='contact-form'>
                <div class="container-block form-wrapper">
                  <div class="head-text-box">
                    {/* <p class="text-blk contactus-head">
                    Contact us
                  </p> */}
                    <p class="text-blk contactus-subhead">
                      I am always eager to hear from you! Whether you have any questions, suggestions or feedback for me, please don't hesitate to get in touch. You can reach out to me through email or phone, or simply fill out the contact form on this page and i'll get back to you as soon as possible. I look forward to hearing from you!
                    </p>
                  </div>
                  <div class="responsive-container-block">
                    <div class="responsive-cell-block wk-ipadp-6 wk-tab-12 wk-mobile-12 wk-desk-6" id="i10mt-6">
                      <p class="text-blk input-title">
                        FIRST NAME
                      </p>
                      <input type='text' class="input" id="ijowk-6" name="FirstName" required />
                    </div>
                    <div class="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                      <p class="text-blk input-title">
                        LAST NAME
                      </p>
                      <input type='text' class="input" id="indfi-4" name="LastName" required />
                    </div>
                    <div class="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                      <p class="text-blk input-title">
                        EMAIL
                      </p>
                      <input class="input" type='email' id="ipmgh-6" name="Email" required />
                    </div>
                    <div class="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                      <p class="text-blk input-title">
                        PHONE NUMBER
                      </p>
                      <input type='number' class="input" id="imgis-5" name="PhoneNumber" pattern="^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$" required />
                    </div>
                    <div class="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-12 wk-ipadp-12" id="i634i-6">
                      <p class="text-blk input-title">
                        WHAT DO YOU HAVE IN MIND
                      </p>
                      <textarea class="textinput" id="i5vyy-6" placeholder="Please enter query..." name='message' required></textarea>
                    </div>
                  </div>
                  <div class="btn-wrapper">
                    <button class="submit-btn" type="submit" disabled={state.submitting}>
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-5 wk-ipadp-10" id="ifgi">
              <div class="container-box">
                <div class="text-content">
                  {/* <p class="text-blk contactus-head">
                  Contact us
                </p> */}
                  <p class="text-blk contactus-subhead">
                    I am always eager to hear from you! Whether you have any questions, suggestions or feedback for me, please don't hesitate to get in touch. You can reach out to me through email or phone, or simply fill out the contact form on this page and i'll get back to you as soon as possible. I look forward to hearing from you!
                  </p>
                </div>
                <div class="workik-contact-bigbox">
                  <div class="workik-contact-box">
                    <div class="phone text-box">
                      <img class="contact-svg" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/ET21.jpg" alt='' />
                      <p class="contact-text">
                        +91 97379 75985
                      </p>
                    </div>
                    <div class="address text-box">
                      <img class="contact-svg" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/ET22.jpg" alt='' />
                      <p class="contact-text">
                        <a href="mailto:dharmeshkporiya@gmail.com">dharmeshkporiya@gmail.com</a>
                      </p>
                    </div>
                    <div class="mail text-box">
                      <img class="contact-svg" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/ET23.jpg" alt='' />
                      <p class="contact-text">
                        Kamal park society, Surat, Gujarat, India.
                      </p>
                    </div>
                  </div>
                  <div class="social-media-links">
                    <a href="https://github.com/dharmesh-poriya" target='_blank' rel='noreferrer'>
                      <img class="social-svg" id="is9ym" src="https://cdns.iconmonstr.com/wp-content/releases/preview/2012/240/iconmonstr-github-1.png" alt='github' />
                    </a>
                    <a href="https://twitter.com/D_Poriya_05" target='_blank' rel='noreferrer'>
                      <img class="social-svg" id="i706n" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/gray-twitter.svg" alt='twitter' />
                    </a>
                    <a href="https://www.instagram.com/_dharmesh.poriya_/" target='_blank' rel='noreferrer'>
                      <img class="social-svg" id="ib9ve" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/gray-insta.svg" alt='instagram' />
                    </a>
                    <a href="https://www.facebook.com/d.poriya03" target='_blank' rel='noreferrer'>
                      <img class="social-svg" id="ie9fx" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/gray-fb.svg" alt='facebook' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <iframe className='col-12 mb-5 vh-100' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.734091544627!2d72.85224171490069!3d21.202719685904384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f007de167ab%3A0xa3bdf3e331199567!2sKamal%20Park%20Society!5e0!3m2!1sen!2sin!4v1678360582841!5m2!1sen!2sin" style={{ border: '0' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Dharmesh Poriya's Home"></iframe>
        </div>
        
      </div>
    </>
  )
}

export default Contact